import { useCallback, useState } from "react";
// src/hooks/useElement.ts
/**
* A callback ref that reports the element it is attached to.
*
* - Detachment runs through the ref's cleanup, not a `null` call.
* - A branch swap never exposes `null` between the outgoing and incoming node.
* - A branch with no ref still releases the old node, so its listeners don't leak.
*/
const useElement = () => {
	const [element, setElement] = useState(null);
	return [element, useCallback((node) => {
		if (node === null) return;
		setElement(node);
		return () => setElement((prev) => prev === node ? null : prev);
	}, [])];
};
export { useElement };

//# sourceMappingURL=useElement-Dcoo9Jlr.js.map